import PropTypes from "prop-types";
import React, { use, useEffect } from "react";
import { useState } from "react";
import { Modal, ModalBody } from "reactstrap";

const RestrictChannelsModal = ({ show, onRestrictClick, onCloseClick }) => {
  const [reason, setReason] = useState(null);

  return (
    <Modal isOpen={show} toggle={onCloseClick} centered={true}>
      <ModalBody className="py-3 px-5">
        <div className="mt-2 text-center">
          <lord-icon
            src="https://cdn.lordicon.com/gsqxdxog.json"
            trigger="loop"
            colors="primary:#f7b84b,secondary:#f06548"
            style={{ width: "100px", height: "100px" }}
          ></lord-icon>
          <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
            <p className="text-muted mx-4 mb-0">
              Select Channel(s) to Restrict
            </p>
          </div>
          <select
            className="form-control w-md"
            data-choices
            data-choices-search-false
            onChange={(e) => setReason(e.target.value)}
          >
            <option value="" defaultValue>
              Choose a Channel
            </option>
            <option key="0" value="0">
              No Restrictions
            </option>
            <option key="1" value="1">
              Amazon
            </option>
            <option key="2" value="2">
              Walmart
            </option>
            <option key="3" value="3">
              Amazon and Walmart
            </option>
            <option key="4" value="4">
              eBay
            </option>
            <option key="5" value="5">
              Amazon and eBay
            </option>
            <option key="6" value="6">
              eBay and Walmart
            </option>
            <option key="7" value="7">
              Amazon, Walmart and eBay
            </option>
            <option key="8" value="8">
              Other
            </option>
            <option key="9" value="9">
              Other and Amazon
            </option>
            <option key="10" value="10">
              Other and Walmart
            </option>
            <option key="11" value="11">
              Other, Amazon and Walmart
            </option>
            <option key="12" value="12">
              Other and eBay
            </option>
            <option key="13" value="13">
              Other, Amazon and eBay
            </option>
            <option key="14" value="14">
              Other, Walmart and eBay
            </option>
            <option key="15" value="15">
              Other, Amazon, Walmart and eBay
            </option>
          </select>
        </div>
        <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
          <button
            type="button"
            className="btn w-sm btn-light"
            data-bs-dismiss="modal"
            onClick={onCloseClick}
          >
            Close
          </button>
          <button
            type="button"
            disabled={!reason || reason === ""}
            className="btn w-sm btn-danger "
            id="delete-record"
            onClick={() => onRestrictClick(reason)}
          >
            Yes, Restrict It!
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
};

RestrictChannelsModal.propTypes = {
  onCloseClick: PropTypes.func,
  onRestrictClick: PropTypes.func,
  show: PropTypes.any,
};

export default RestrictChannelsModal;
